import { useMediaQuery as e } from "react-responsive";
import i from "prop-types";
import { largeDesktop as a, desktop as l, laptop as m, tablet as n, mobile as u } from "mintel-tokens";
const b = () => {
  const t = e({
    query: `(min-width: ${a})`
  }) && "largeDesktop", o = e({
    query: `(min-width: ${l})`
  }) && "desktop", r = e({
    query: `(min-width: ${m})`
  }) && "laptop", p = e({
    query: `(min-width: ${n})`
  }) && "tablet", s = e({
    query: `(min-width: ${u})`
  }) && "mobile";
  return t || o || r || p || s || "xs";
}, c = i.oneOf([
  "xs",
  "mobile",
  "tablet",
  "laptop",
  "desktop",
  "largeDesktop"
]);
export {
  c as d,
  b as u
};
